import { createAsyncAction, createAction } from "typesafe-actions";

import {
  AuditLogDetail,
  AuditLogFilter,
  AuditLogFilterOptions,
  AuditLogListResponse,
  AuditLogRequestError,
} from "../interfaces";
import { AuditLogActionTypes } from "./constants";

export const getAuditLogs = createAsyncAction(
  AuditLogActionTypes.GET_AUDIT_LOGS,
  AuditLogActionTypes.GET_AUDIT_LOGS_SUCCESS,
  AuditLogActionTypes.GET_AUDIT_LOGS_FAILURE,
)<AuditLogFilter, AuditLogListResponse, AuditLogRequestError>();

export const getAuditLogFilters = createAsyncAction(
  AuditLogActionTypes.GET_AUDIT_LOG_FILTERS,
  AuditLogActionTypes.GET_AUDIT_LOG_FILTERS_SUCCESS,
  AuditLogActionTypes.GET_AUDIT_LOG_FILTERS_FAILURE,
)<void, AuditLogFilterOptions, AuditLogRequestError>();

export const getAuditLogDetail = createAsyncAction(
  AuditLogActionTypes.GET_AUDIT_LOG_DETAIL,
  AuditLogActionTypes.GET_AUDIT_LOG_DETAIL_SUCCESS,
  AuditLogActionTypes.GET_AUDIT_LOG_DETAIL_FAILURE,
)<number, AuditLogDetail, AuditLogRequestError>();

export const setFilter = createAction(AuditLogActionTypes.SET_FILTER)<AuditLogFilter>();
export const clearAuditLogs = createAction(AuditLogActionTypes.CLEAR_AUDIT_LOGS)();
export const clearDetail = createAction(AuditLogActionTypes.CLEAR_DETAIL)();
